<template>
  <div class="card">
    <div class="card-header d-flex align-items-center justify-content-between">
      <h3 class="card-title mb-0">Registru Jurnal</h3>
      <div class="d-flex gap-2">
        <button type="button" class="btn btn-sm btn-light-primary" @click="reload">
          <i class="fa fa-rotate-right me-1"></i>
          Reîncarcă
        </button>
      </div>
    </div>
    <div class="card-body">
      <!-- Filtre Registru Jurnal -->
      <div class="mb-5">
        <form @submit.prevent="applyFilters">
          <div class="row g-3 align-items-end">
            <div class="col-md-3">
              <label class="form-label">Perioadă de la</label>
              <input type="date" class="form-control" v-model="filters.data_start" />
            </div>
            <div class="col-md-3">
              <label class="form-label">Perioadă până la</label>
              <input type="date" class="form-control" v-model="filters.data_end" />
            </div>
            <div class="col-md-3">
              <label class="form-label">Tip document</label>
              <input type="text" class="form-control" placeholder="ex: Factura_intrare, Factura_iesire..."
                v-model="filters.tip_document" />
            </div>
            <div class="col-md-3">
              <label class="form-label">Document sursă</label>
              <input type="text" class="form-control" placeholder="Caută în descriere / sursă"
                v-model="filters.document_sursa" />
            </div>

            <div class="col-md-3">
              <label class="form-label">Cont (D/C)</label>
              <input type="text" class="form-control" placeholder="ex: 5121, 411.01..." v-model="filters.cont" />
            </div>
            <div class="col-md-2">
              <label class="form-label">Sumă minimă</label>
              <input type="number" step="0.01" class="form-control" v-model.number="filters.suma_min" />
            </div>
            <div class="col-md-2">
              <label class="form-label">Sumă maximă</label>
              <input type="number" step="0.01" class="form-control" v-model.number="filters.suma_max" />
            </div>
            <div class="col-md-3">
              <label class="form-label">Căutare generală</label>
              <input type="text" class="form-control" placeholder="Explicație, număr document..."
                v-model="filters.search" />
            </div>

            <div class="col-md-2 text-end">
              <button type="button" class="btn btn-primary me-2" @click="applyFilters">
                <i class="fa fa-search me-1"></i>
                Aplică filtre
              </button>
              <button type="button" class="btn btn-light" @click="resetFilters">
                Reset
              </button>
            </div>
          </div>
        </form>
      </div>

      <!-- Tabel Registru Jurnal -->
      <!-- Mesaje stare tabel -->
      <div v-if="loading" class="text-center py-4">
        Se încarcă înregistrările din Registru Jurnal...
      </div>
      <div v-else-if="!linii.length" class="text-center text-muted py-4">
        Nu există înregistrări în Registru Jurnal pentru această firmă și filtru.
      </div>
      <div class="table-responsive">
        <table class="table table-bordered table-striped align-middle" id="tabel_registru_jurnal">
          <thead>
            <tr class="text-uppercase fw-bold">
              <th style="width: 40px" class="text-center">#</th>
              <th style="width: 110px;">Data doc</th>
              <th style="width: 110px;">Data înreg.</th>
              <th style="width: 120px;">Tip document</th>
              <th style="width: 150px;">Document</th>
              <th>Document sursă</th>
              <th>Explicație</th>
              <th style="width: 110px;">Cont D</th>
              <th style="width: 110px;">Cont C</th>
              <th style="width: 120px;" class="text-end">Sumă</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(linie, index) in linii" :key="linie.linie_id">
              <td class="text-center">{{ index + 1 }}</td>
              <td>{{ formatDate(linie.doc_data) || '-' }}</td>
              <td>{{ formatDate(linie.data_inregistrare) || '-' }}</td>
              <td>{{ linie.tip_document || '-' }}</td>
              <td style="cursor: pointer;" @click="openDetalii(linie)" title="Click pentru detalii document">
                <div>
                  <strong>
                    {{ (linie.doc_serie || '') + (linie.doc_numar || '-') }}
                  </strong>
                </div>
              </td>
              <td>{{ linie.doc_descriere || '-' }}</td>
              <td>{{ linie.explicatie || '-' }}</td>
              <td>
                <div>{{ linie.cont_debit_cod || '-' }}</div>
                <small class="text-muted" v-if="linie.cont_debit_descriere">
                  {{ linie.cont_debit_descriere }}
                </small>
              </td>
              <td>
                <div>{{ linie.cont_credit_cod || '-' }}</div>
                <small class="text-muted" v-if="linie.cont_credit_descriere">
                  {{ linie.cont_credit_descriere }}
                </small>
              </td>
              <td class="text-end">
                {{ formatMoney(linie.suma_ron) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- Modal detalii document Registru Jurnal -->
      <div class="modal fade" id="modalDetaliiRJ" tabindex="-1" aria-labelledby="modalDetaliiRJLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="modalDetaliiRJLabel">
                Detalii document Registru Jurnal
              </h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div v-if="loadingDetalii" class="text-center py-4">
                Se încarcă detaliile documentului...
              </div>
              <div v-else-if="!docDetaliiAntet">
                <div class="alert alert-warning mb-0">
                  Nu s-au putut încărca detaliile documentului.
                </div>
              </div>
              <div v-else>
                <!-- Antet document -->
                <div class="mb-4">
                  <h6 class="fw-bold mb-2">
                    {{ docDetaliiAntet.tip_document || 'Document' }}
                  </h6>
                  <div class="row g-2 small text-muted">
                    <div class="col-md-4">
                      <span class="fw-semibold">Număr:</span>
                      {{ (docDetaliiAntet.doc_serie ? docDetaliiAntet.doc_serie + ' ' : '') + (docDetaliiAntet.doc_numar
                        || '-') }}
                    </div>
                    <div class="col-md-4">
                      <span class="fw-semibold">Data document:</span>
                      {{ formatDate(docDetaliiAntet.doc_data) || '-' }}
                    </div>
                    <div class="col-md-4">
                      <span class="fw-semibold">Descriere:</span>
                      {{ docDetaliiAntet.doc_descriere || '-' }}
                    </div>
                  </div>
                </div>

                <!-- Linii contabile -->
                <div class="table-responsive">
                  <table class="table table-sm table-bordered align-middle">
                    <thead class="table-light">
                      <tr class="text-uppercase small">
                        <th style="width: 40px" class="text-center">#</th>
                        <th style="width: 120px;">Data înreg.</th>
                        <th style="width: 120px;">Cont D</th>
                        <th style="width: 120px;">Cont C</th>
                        <th>Explicație</th>
                        <th style="width: 130px;" class="text-end">Sumă</th>
                        <th style="width: 90px;">Monedă</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(l, idx) in docDetaliiLinii" :key="l.id || idx">
                        <td class="text-center">{{ idx + 1 }}</td>
                        <td>{{ formatDate(l.data_inregistrare) || '-' }}</td>
                        <td>
                          <div>{{ l.cont_debit_cod_complet || '-' }}</div>
                          <small class="text-muted" v-if="l.cont_debit_descriere">
                            {{ l.cont_debit_descriere }}
                          </small>
                        </td>
                        <td>
                          <div>{{ l.cont_credit_cod_complet || '-' }}</div>
                          <small class="text-muted" v-if="l.cont_credit_descriere">
                            {{ l.cont_credit_descriere }}
                          </small>
                        </td>
                        <td>{{ l.descriere || l.explicatie || '-' }}</td>
                        <td class="text-end">
                          {{ formatMoney(l.suma_ron ?? l.suma_moneda_doc) }}
                        </td>
                        <td>{{ l.moneda || docDetaliiAntet.moneda || '-' }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Documente Repartizate (Facturi pt Plati sau Plati pt Facturi) -->
                <div v-if="docDetaliiAntet.repartizari && docDetaliiAntet.repartizari.length > 0" class="mt-4">
                  <h6 class="fw-bold mb-3">
                    <i class="fa fa-money-bill-transfer me-2"></i>
                    <span v-if="isInvoice(docDetaliiAntet.tip_document)">Istoric Încasări / Plăți</span>
                    <span v-else>Documente Repartizate</span>
                  </h6>
                  <div class="table-responsive">
                    <table class="table table-sm table-bordered border-success">
                      <thead class="bg-light-success">
                        <tr class="small text-uppercase">
                          <th>Data</th>
                          <th>Document</th>
                          <th>Tip</th>
                          <th class="text-end">Sumă</th>
                          <th>Detalii Contabile (D / C)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(r, idx) in docDetaliiAntet.repartizari" :key="idx">
                          <td>{{ formatDate(r.data) }}</td>
                          <td><strong>{{ r.numar }}</strong></td>
                          <td><small class="text-muted">{{ r.tip }}</small></td>
                          <td class="text-end fw-bold text-success">{{ formatMoney(r.suma) }}</td>
                          <td>
                            <div v-for="(l, lIdx) in r.rj_linii" :key="lIdx"
                              class="small border-bottom border-light pb-1 mb-1">
                              <span class="badge badge-light-primary">{{ l.cont_debit_cod_complet }}</span>
                              <i class="fa fa-arrow-right mx-1 text-muted"></i>
                              <span class="badge badge-light-success">{{ l.cont_credit_cod_complet }}</span>
                              <div class="text-muted" style="font-size: 0.75rem;">{{ l.descriere }}</div>
                            </div>
                            <div v-if="!r.rj_linii || r.rj_linii.length === 0" class="text-muted small">
                              Fără înregistrări RJ găsite.
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div v-else-if="shouldShowRepartizariAlert(docDetaliiAntet.tip_document)"
                  class="alert alert-light-warning py-2 border-0 mt-3">
                  <i class="fa fa-info-circle me-2"></i> Nu există documente repartizate corelate (repartizarea nu a
                  fost efectuată).
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">
                Închide
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>

<script>
export default {
  name: 'RegistruJurnal',
  data() {
    return {
      filters: new Form({
        data_start: '',
        data_end: '',
        tip_document: '',
        document_sursa: '',
        cont: '',
        suma_min: '',
        suma_max: '',
        search: '',
      }),
      linii: [],
      loading: false,
      dtRegistru: null,
      docDetaliiAntet: null,
      docDetaliiLinii: [],
      loadingDetalii: false,
    }
  },
  mounted() {
    this.loadRegistru()
  },
  methods: {
    formatDate(d) {
      if (!d) return ''
      try {
        return new Date(d).toLocaleDateString('ro-RO')
      } catch (e) {
        return ''
      }
    },
    formatMoney(v) {
      const n = Number(v || 0)
      return n.toLocaleString('ro-RO', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    },
    initDataTable() {
      if (this.dtRegistru && this.dtRegistru.destroy) {
        this.dtRegistru.destroy()
        this.dtRegistru = null
      }
      // Dacă nu avem linii, nu inițializăm DataTables pentru a evita eroarea de număr de coloane
      if (!this.linii || this.linii.length === 0) {
        return
      }

      if (!window.$ || !window.$.fn || !window.$.fn.DataTable) {
        return
      }

      const $table = window.$('#tabel_registru_jurnal')
      if (!$table.length) return

      this.dtRegistru = $table.DataTable({
        paging: true,
        searching: true,
        info: true,
        ordering: true,
        pageLength: 25,
        order: [[0, 'asc']],
        language: {
          url: 'https://cdn.datatables.net/plug-ins/1.13.6/i18n/ro.json',
          search: 'Caută:',
          lengthMenu: 'Afișează _MENU_ înregistrări',
          info: 'Afișate _START_ - _END_ din _TOTAL_ înregistrări',
          infoEmpty: 'Nu sunt date',
          zeroRecords: 'Nu am găsit nimic',
          paginate: {
            first: 'Prima',
            last: 'Ultima',
            next: '›',
            previous: '‹',
          },
        },
      })
    },
    async loadRegistru() {
      this.loading = true

      // distrugem instanța DataTables înainte de re-render
      if (this.dtRegistru && this.dtRegistru.destroy) {
        this.dtRegistru.destroy()
        this.dtRegistru = null
      }

      try {
        const params = {
          data_start: this.filters.data_start || null,
          data_end: this.filters.data_end || null,
          tip_document: this.filters.tip_document || null,
          document_sursa: this.filters.document_sursa || null,
          cont: this.filters.cont || null,
          suma_min: this.filters.suma_min || null,
          suma_max: this.filters.suma_max || null,
          search: this.filters.search || null,
          per_page: 5000, // luăm mai multe rânduri și lăsăm DataTables să se ocupe de paginare
        }

        const res = await axios.get('/api/contabilitate/rj/linii', {
          params,
        })

        const data = res.data
        this.linii = Array.isArray(data)
          ? data
          : data.items || []

        this.$nextTick(() => {
          this.initDataTable()
        })
      } catch (e) {
        console.error('Eroare la încărcarea Registrului Jurnal:', e)
        this.linii = []
        const msg =
          e?.response?.data?.error ||
          'Nu s-au putut încărca înregistrările din Registru Jurnal.'
        if (window.Swal) {
          window.Swal.fire({
            icon: 'error',
            title: 'Eroare',
            text: msg,
          })
        } else if (window.toastr) {
          window.toastr.error(msg)
        }
      }

      this.loading = false
    },
    applyFilters() {
      this.loadRegistru()
    },
    resetFilters() {
      if (this.filters && typeof this.filters.reset === 'function') {
        this.filters.reset()
      } else {
        this.filters = new Form({
          data_start: '',
          data_end: '',
          tip_document: '',
          document_sursa: '',
          cont: '',
          suma_min: '',
          suma_max: '',
          search: '',
        })
      }
      this.loadRegistru()
    },
    reload() {
      this.loadRegistru()
    },
    async openDetalii(linie) {
      if (!linie || !linie.reg_jurnal_id) {
        return
      }

      this.loadingDetalii = true
      this.docDetaliiAntet = null
      this.docDetaliiLinii = []

      try {
        const res = await axios.get(
          `/api/contabilitate/rj/show/${linie.reg_jurnal_id}`
        )

        const data = res.data || {}

        // la tine backend-ul trimite antetul direct la rădăcină + 'linii'
        this.docDetaliiAntet = data
        this.docDetaliiLinii = Array.isArray(data.linii) ? data.linii : []

        this.$nextTick(() => {
          if (window.$) {
            window.$('#modalDetaliiRJ').modal('show')
          }
        })
      } catch (e) {
        console.error('Eroare la încărcarea detaliilor RJ:', e)
        const msg =
          e?.response?.data?.error ||
          'Nu s-au putut încărca detaliile documentului din Registru Jurnal.'
        if (window.Swal) {
          window.Swal.fire({
            icon: 'error',
            title: 'Eroare',
            text: msg,
          })
        } else if (window.toastr) {
          window.toastr.error(msg)
        }
      }

      this.loadingDetalii = false
    },
    isInvoice(tip) {
      if (!tip) return false
      const t = tip.toLowerCase()
      return t.includes('factura_iesire') || t.includes('factura iesire') ||
        t.includes('factura_intrare') || t.includes('factura intrare')
    },
    shouldShowRepartizariAlert(tip) {
      if (!tip) return false
      const t = tip.toLowerCase()
      const list = ['chitanta', 'ordin plata', 'ordin_plata', 'dispozitie', 'factura']
      return list.some(item => t.includes(item))
    },
  },
}
</script>

<style scoped>
#tabel_registru_jurnal {
  width: 100% !important;
}
</style>